import * as React from 'react';
import { fetchStreamIdIfNeeded, getStreamStatus } from '@/redux/modules/video';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import AuctionVideo from '@liveauctioneers/caterwaul-components/lib/AuctionVideo/NewAuctionVideo';
import styled from 'styled-components';

type Props = {
    catalogId: number;
    className?: string;
    muted?: boolean;
    onClick?: () => void;
    showControls?: boolean;
    showExpandButton?: boolean;
    standAlone?: boolean;
};

/**
 * Video player for auction livestream
 */
const AuctionVideoStream = ({
    catalogId,
    className,
    muted = true,
    onClick,
    showControls = true,
    showExpandButton = true,
    standAlone,
}: Props) => {
    const dispatch = useAppDispatch();
    const { streamId } = useAppSelector((state) => getStreamStatus(state, catalogId));

    return (
        <StyledVideoContainer>
            <StyledAuctionVideo
                catalogId={catalogId}
                className={className}
                fetchStreamIdIfNeeded={() => dispatch(fetchStreamIdIfNeeded(catalogId))}
                handleClick={onClick}
                muted={muted}
                showControls={showControls}
                showExpandIcon={showExpandButton}
                standAlone={standAlone}
                streamId={streamId}
            />
        </StyledVideoContainer>
    );
};

export default AuctionVideoStream;

const StyledVideoContainer = styled.div`
    // adding this padding top will allow the container to maintain a 16/9 aspect ratio
    padding-top: 56.25% !important;
    width: 100%;
    position: relative;
`;

const StyledAuctionVideo = styled(AuctionVideo)`
    && {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }
`;
